import { Component, OnInit } from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

import { ThemeService } from './shared/theme.service';
import { SiteThemeService } from './shared/site-theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'aiii-med';
  private routerSubscription!: Subscription;

  constructor(
    private router: Router,
    private themeService: ThemeService,
    private siteThemeService: SiteThemeService
  ) {}

  ngOnInit(): void {
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.initializeTheme();
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private async initializeTheme(): Promise<void> {
    const url = new URL(window.location.href);
    const site = url.searchParams.get('site');

    if (site) {
      const theme = await this.siteThemeService.getTheme(site);
      if (theme) {
        this.themeService.setTheme(theme);
      }
    }
  }
}
